/* istanbul ignore file */
export enum BookingColumnNames {
  Index = "index",
  Source = "source",
  Resident = "resident",
  Notes = "notes",
  Area = "area",
  Status = "status",
  Paid = "isPaid",
  Delete = "delete"
}
